import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  DataService,
  OptionsserviceService,
  UserService,
  OperationsService
} from '../_services/index';
import {
  LoansService,
  AuthenticationService,
  StorageService,
  CustomerService
} from '../_services/index';
import { AnalyticsService } from '../_services/index';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ProductsService } from 'src/app/_services/products.service';

import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-home-approval',
  templateUrl: './home-approval.component.html',
  styleUrls: ['./home-approval.component.css', './boot-outline-btn.css', './style.css']
})
export class HomeApprovalComponent implements OnInit, OnDestroy {
  endDate = '1561071600000';
  text = 'Invite a Customer';
  modifying_bureau_settings = false;
  externalsettingopen = '';
  pictureshown = 'profile';
  sideview = 'master';
  bsrequest = {
    password: '',
    duration: '6',
    recent_check: true,
    url: ''
  };
  go_live_details = {
    interest_rate: '',
    interest_rate_period_id: '',
    max_amount: '0',
    plan: '1'
  }
  statement: any;
  min = 0;
  max = 100;
  min_ = 0;
  max_ = 10000000;
  filteringLoans = false;
  bureau_selected = '1';
  loan_: any;
  appKey = '';
  miniSearch = false;
  searchView = false;
  loading = false;
  currentUser: any;
  sample_user: any;
  loans: any;
  overlayOpen = false;
  loan: any;
  request_id: any;
  overlayModalSection = '';
  simulateSection = 'default';
  isedit = '1';
  sub: any;
  adding_more = false;
  kyc_type_id = '1';
  repayment_mode = '0';
  test_mode = JSON.parse(localStorage.getItem('test_mode'));
  appKeys = localStorage.getItem('appKey');
  activeRequestId = null;
  goLiveSection = "home";

  public durations = [
    { display: '0 - 1', checked: false, min: 0, max: 30 },
    { display: '0 - 3', checked: false, min: 31, max: 90 },
    { display: '4 - 6', checked: false, min: 91, max: 180 },
    { display: '7 - 12', checked: false, min: 181, max: 365 },
    { display: '1+ Years', checked: false, min: 366, max: 3650 }
  ];
  public adays = [
    { display: '1 - 3', checked: false, min: 0, max: 3 },
    { display: '4 - 10', checked: false, min: 4, max: 10 },
    { display: '> 10', checked: false, min: 10, max: 365 }
  ];

  public incomes = [
    { display: '< 50K', checked: false, min: 0, max: 50000 },
    { display: '51 - 100k', checked: false, min: 50001, max: 100000 },
    { display: '101k - 250k', checked: false, min: 100001, max: 250000 },
    { display: '250k - 500k', checked: false, min: 250001, max: 500000 },
    { display: '500k - 1m', checked: false, min: 500001, max: 1000000 },
    { display: '> 1m', checked: false, min: 1000001, max: 120000000 }
  ];
  public ages = [
    { display: '18 - 24', checked: false, min: 18, max: 24 },
    { display: '25 - 34', checked: false, min: 25, max: 34 },
    { display: '35 - 45', checked: false, min: 35, max: 45 },
    { display: 'above 45', checked: false, min: 46, max: 100 }
  ];
  choosingKYC = false;
  public request_date = [
    { display: 'Today', checked: false, min: 0, max: 1 },
    { display: '2 - 7 days', checked: false, min: 2, max: 7 },
    { display: '2 - 4 weeks', checked: false, min: 8, max: 30 },
    { display: '1+ months', checked: false, min: 31, max: 100000 }
  ];
  public statuses = [
    // { value: '-2', display: 'All' },
    { value: '-6', display: 'Terminated' },
    { value: '-4', display: 'Disbursements' },
    { value: '5', display: 'Rejected' },
    { value: '-3', display: 'Ineligible' },
    { value: '6', display: 'Contract Created' }
  ];
  magic_filter = {
    repayment_status: '0',
    repayment_mode: '0',
    customer_category: '0',
    company_id: '',
    product_id: '',
    peer_to_peer: '',
    reset: false,
    my_approvals: false,
    account_officer: false,
    start: 0,
    funding: '100',
    token: '',
    min: 0,
    max: 10000000,
    loan_status: '1',
    searchText: '',
    ratings_one: false,
    ratings_two: false,
    ratings_three: false,
    ratings_four: false,
    ratings_five: false,
    funding_amount_one: 1,
    funding_amount_two: 1,
    funding_amount_three: false,
    funding_status_disbursement: false,
    funding_status_contract_created: false,
    funding_status_applied: false,
    funding_status_funded: false,
    funding_status: false,
    amount: false,
    approval_level: false,
    rating: false,
    sector: false,
    date: false
  };
  sectors: any;
  companies: any;
  approval_levels: any;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  direction = '';
  cards = 'cards';
  accountdebit = 'accountdebit';
  open_approval = false;
  approving = false;
  rejecting = false;
  kyc_request = {
    KYC_COMMENTS: '',
    KYC_TYPE_ONE: false,
    KYC_TYPE_TWO: false,
    KYC_PACKAGE: '',
    KYC_TYPE_ID: '1',
    REQUEST_ID: '0'
  };
  financials_request = {
    HOW_MANY_MONTHS: '',
    BANK_STATEMENTS: false,
    PAYSLIPS: false
  };
  guarantors_request = {
    HOW_MANY_GUARANTORS: ''
  };
  pickup = {
    KYC_COMMENTS: '',
    PICKUP_ADDRESS_TYPE: '1',
    CUSTOM_PICKUP_ADDRESS: '',
    PICKUP_PACKAGE: ''
  };
  rejection = {
    MESSAGE: '',
    SEND_REJECTION_MAIL: false
  };
  reopen = {
    MESSAGE: '',
    SEND_REOPEN_MAIL: false,
    SUSPEND_CUSTOMER: false,
    SUSPEND_FOR_HOW_LONG: '24'
  };
  public other_docs = [
    {
      display: 'Valid ID Card',
      value: '1',
      checked: false
    },
    {
      display: 'Other ID Card',
      value: '15',
      checked: false
    },
    {
      display: 'Payslips',
      value: '6',
      checked: false
    },
    {
      display: 'Bank Statements',
      value: '7',
      checked: false
    },
    {
      display: 'Employment Letter',
      value: '8',
      checked: false
    },
    {
      display: 'Purchase Order',
      value: '9',
      checked: false
    },
    {
      display: 'Invoices',
      value: '10',
      checked: false
    },
    {
      display: 'Certificate of Incorporation',
      value: '11',
      checked: false
    },
    {
      display: 'Company Profile',
      value: '12',
      checked: false
    },
    {
      display: 'Allotment of Shares',
      value: '13',
      checked: false
    },
    {
      display: 'Particulars of Directors',
      value: '14',
      checked: false
    },
    {
      display: 'Work ID Card',
      value: '16',
      checked: false
    },
    {
      display: 'Utility Bill',
      value: '17',
      checked: false
    },
    {
      display: 'National ID',
      value: '18',
      checked: false
    },
    {
      display: 'Voter ID',
      value: '19',
      checked: false
    },
    {
      display: 'International Passport',
      value: '20',
      checked: false
    },
    {
      display: 'Offer Letter (Previous Loan)',
      value: '21',
      checked: false
    },
    {
      display: 'Confirmation Letter',
      value: '22',
      checked: false
    }
  ];
  public bureaus = [
    {
      display: 'CRC',
      checked: true,
      value: '1'
    },
    {
      display: 'First Central(XDS)',
      checked: false,
      value: '2'
    },
    {
      display: 'CRServices',
      checked: false,
      value: '3'
    }
  ];
  products: any;
  docpickups: any;
  doctypes: any;
  public level: any;
  public prev_levels: any;
  public model_r = {
    ilo: 0,
    reject_reason: '',
    reject_action: '',
    approval_notes: '',
    reject_level: '',
    wtd: 0,
    request_id: '',
    level: ''
  };
  public model_a = {
    chk_acts: [],
    past_one: 1,
    approval_all_waivers: 1,
    approval_all_checklist: 1,
    is_waiver_level: 0,
    has_waiver: 0,
    ilo: 0,
    istd: 0,
    approval_notes: '',
    wtd: 1,
    request_id: '',
    level: ''
  };
  disbursing_request = false;
  disburse: any;
  islarger = true;
  public is_done = '0';
  banks: any;
  childModal = { location: '', data: {} };
  account_for_direct_debit: any;
  overlayEditModalSection = '';
  nodes_and_scores: any;
  selected_analytics = '1';
  analytics_last_done = '';
  changingofficer = false;
  attachment_for_analysis: any;
  date_chosen: any;
  show_approval_calendar = false;
  view_status = 'requests';
  calendar_from = '0';
  calendar_type = '0';
  analysing_statement = false;
  where = '';
  showPicture = false;
  sms_value: any;
  guarantor_value: any;
  call_logs_value: any;
  cards_value: any;
  profile_value: any;
  social_value: any;
  accounts_value: any;
  dd_value: any;
  repayment_value: any;
  lender_id: any;
  borrower_id: any;
  principal: any;
  maturity_date: any;
  account_card_id: any;
  loan_request_id: any;
  card_id: any;
  passed_analytics: any;
  failed_analytics: any;
  number_passed: number;
  number_failed: number;
  analytics_score: number;
  profile_pic: any;
  occupations: any;
  designations: any;
  platform_summary: any;
  public marital_statuses = [
    // { value: '-2', display: 'All' },
    { value: '1', display: 'Single' },
    { value: '2', display: 'Married' },
    { value: '3', display: 'Divorced' },
    { value: '4', display: 'Widowed' },
  ];
  invitingCustomer = false;
  invitingMultipleCustomer = false;
  bvn_value: any;
  url: string = 'https://creditclanapis.creditclan.com/api/v2/dashboard';
  view = 'master';
  constructor(
    public toastr: ToastrService,
    public storageService: StorageService,
    public analyticsService: AnalyticsService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    private router: Router,
    private dataService: DataService,
    private authService: AuthenticationService,
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private operationsService: OperationsService,
    private productService: ProductsService,
    private http: HttpClient
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.sample_user = this.storageService.read<any>('sample_user');

  }
  ngOnInit() {
    this.getApprovals();
    let url = this.router.url;
    const tokens = url.split('/');
    if (tokens.length == 5) {
      this.view = 'sub';
    }
  }
  getLoanLink(status) {
    this.filteringLoans = true;
    this.magic_filter.loan_status = status;
    this.getLoans();
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  selectPlan(plan) {
    this.go_live_details.plan = plan;
  }
  doingDisbursement(event) {

    event.new_loan = this.loan;
    console.log(event)
    this.dataService.disbursingRequest.emit(event);
  }
  openModal(section) {
    if (section == 'location') {
      if (this.test_mode == '1') {
        this.dataService.onOpenLoanChildModal.emit({ 'location': 'test_mode', request_id: this.loan.request_id, loan: this.loan });
      }
    } else {
      this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.loan.request_id, loan: this.loan });
      console.log(this.loan)
    }
  }
  chooseKYCPlan() {
    this.choosingKYC = true;
    this.islarger = true;
  }
  getBanksListForCustomer(loan) {
    this.loansService
      .getBanksListForCustomer(this.currentUser.token, this.request_id)
      .subscribe(data => {
        this.banks = data.banks;
      });
  }
  displayCondition(i) {
    // if (i <= 2) {
    //   return true;
    // } else {
    //   return false;
    // }
    return true;
  }
  checkLevel(sector, event, index) {
    this.durations[index]['checked'] = event;
  }
  checkADay(sector, event, index) {
    this.adays[index]['checked'] = event;
  }
  sendKYCRequest(KYC_PACKAGE) {
    this.kyc_request.KYC_PACKAGE = KYC_PACKAGE;
    this.loading = true;
    this.loansService
      .sendKYCRequest(
        this.currentUser.token,
        this.kyc_request.REQUEST_ID,
        this.kyc_request
      )
      .subscribe(data => {
        this.loading = false;
        this.is_done = '1';
        this.dataService.kycRequestFinished.emit();
      });
  }
  checkActivation() {
    const lender_activated = this.storageService.read<any>('lender_activated');
    const test_mode = this.storageService.read<any>('test_mode');
    if (test_mode == '0' && lender_activated == '0') {
      this.overlayModalSection = 'awaiting_documents';
    }
    if (test_mode == '1') {
      this.getSlimAppSettings();
    }
  }
  showProfilePic(pic) {
    this.dataService.showProfilePic.emit({ pic: pic });
  }
  getSlimAppSettings() {
    this.operationsService
      .getSlimAppSettings(this.currentUser.token)
      .subscribe(data => {
        this.banks = data.banks;
      });
  }
  onScrollDown(ev) {
    if (this.loans.complete == false) {
      this.loadMoreRecords(this.magic_filter.start);
    }

  }
  closeChildModal() {
    this.childModal.location = '';
  }
  loadMoreRecordsAll(start) {
    this.filteringLoans = true;
    this.magic_filter.reset = true;
    this.magic_filter.start = start;
    // this.getLoans()
    this.searchView = false;
    this.magic_filter.token = this.currentUser.token;
    this.adding_more = true;
    if (this.view_status == 'requests') {
      this.loansService
        .filtering_loans(
          this.incomes,
          this.designations,
          this.occupations,
          this.adays,
          this.currentUser.token,
          this.magic_filter,
          this.sectors,
          this.approval_levels,
          this.statuses,
          this.durations,
          this.request_date,
          this.ages,
          this.marital_statuses
        )
        // this.loansService.getLoans(this.magic_filter)
        .subscribe(customers => {
          this.adding_more = false;
          this.loans = customers;
          this.magic_filter.start = customers.start;
        });
    } else if (this.view_status === 'approvals') {
      this.loansService
        .getMyApprovals(this.currentUser.token, this.magic_filter)
        // this.loansService.getLoans(this.magic_filter)
        .subscribe(customers => {
          this.adding_more = false;
          this.loans = customers;
          this.magic_filter.start = customers.start;
        });
    }
  }
  loading_approvals = false;
  pending_approvals: any;
  number_left = '0';
  getPendingApprovals() {
    this.loading_approvals = true;
    return this.http.post<any>(`${this.url}/pendingApprovals`, { token: this.currentUser.token }).subscribe(res => {
      this.loading_approvals = false;
      if (res.status && res.has_data) {
        this.pending_approvals = res;
        this.number_left = res.remaining;
        this.dataService.userhomeloaded.emit({ count: res.dataService });

      }
    }, err => {
      //console.log(err);
    })
  }
  loadMoreRecords(start) {
    this.magic_filter.start = start;
    // this.getLoans()
    this.searchView = false;
    this.magic_filter.token = this.currentUser.token;
    this.adding_more = true;
    if (this.view_status == 'requests') {
      this.loansService
        .filtering_loans(
          this.incomes,
          this.designations,
          this.occupations,
          this.adays,
          this.currentUser.token,
          this.magic_filter,
          this.sectors,
          this.approval_levels,
          this.statuses,
          this.durations,
          this.request_date,
          this.ages,
          this.marital_statuses
        )
        // this.loansService.getLoans(this.magic_filter)
        .subscribe(customers => {
          this.adding_more = false;
          this.loans = customers;
          this.magic_filter.start = customers.start;
        });
    } else if (this.view_status === 'approvals') {
      this.loansService
        .getMyApprovals(this.currentUser.token, this.magic_filter)
        // this.loansService.getLoans(this.magic_filter)
        .subscribe(customers => {
          this.adding_more = false;
          this.loans = customers;
          this.magic_filter.start = customers.start;
        });
    }
  }
  getLoans() {
    this.searchView = false;
    this.loading = true;
    this.magic_filter.token = this.currentUser.token;
    this.loansService
      .filtering_loans(
        this.incomes,
        this.designations,
        this.occupations,
        this.ages,
        this.currentUser.token,
        this.magic_filter,
        this.sectors,
        this.approval_levels,
        this.statuses,
        this.durations,
        this.request_date,
        this.adays,
        this.marital_statuses
      )

      .subscribe(customers => {
        this.filteringLoans = false;
        this.magic_filter.reset = false;
        this.loading = false;
        this.loans = customers;
        this.magic_filter.start = customers.start;
        this.miniSearch = false;
        this.searchView = false;
      });
  }
  getApprovals() {
    this.view_status = 'approvals';
    this.searchView = false;
    this.loading = true;
    this.magic_filter.token = this.currentUser.token;
    this.loansService
      .getMyApprovals(this.currentUser.token, this.magic_filter)

      .subscribe(customers => {
        this.filteringLoans = false;
        this.magic_filter.reset = false;
        this.loading = false;
        this.loans = customers;
        this.magic_filter.start = customers.start;
      });
  }
  openSearchView() { }
  enter() { }
  leave() { }
  searchForLoans() {
    this.loading = true;
    this.loansService
      .searchForLoans(this.currentUser.token, this.magic_filter)
      .subscribe(customers => {
        this.loading = false;
        this.loans = customers;
      });
    // this.getLoans();
  }
  // loadRequest(request) {
  //   this.activeRequestId = request.request.REQUEST_ID;
  //   // let url = './home/approval/requests/' + request.request.REQUEST_ID;
  //   // this.router.navigate([url]);
  // }
  loadRequest(request) { 
    this.reloadCurrentRequestWithId(request.request.REQUEST_ID);
    this.activeRequestId = request.request.REQUEST_ID; 
  }
  reloadCurrentRequestWithId(request_id) {
    this.loan = this.loan_;
    this.sideview = 'placeholder';
    this.activeRequestId = request_id;
    // this.loading = true;
    this.loansService.retrieveLoanDetails(this.currentUser.token, this.activeRequestId)
      .subscribe(data => {
        this.loan = data.loan; 
        this.loading = false;
        this.dataService.onRequestLoadingFromBackend.emit();
        this.dataService.sendBackLoanToCaller.emit({ loan: this.loan });
        this.dataService.loanHomeRequestSideView.emit({ loan: this.loan });
      });
  }
  openRequest(request) {
    this.show_approval_calendar = false;
    this.loadRequest(request)
  }
  goLiveNow() {
    this.loading = true;
    this.authService.goLiveNow(this.currentUser.token, this.go_live_details).subscribe(customers => {
      this.loading = false;
      localStorage.setItem('test_mode', '0');
      this.overlayModalSection = '';
      window.location.reload();
    });
  }
  clearBVN(event) {
    this.customerService
      .retryBVNValidation(this.currentUser.token, event.customer)
      .subscribe(data => {
        this.loading = false;
      });
  }
  retryBVN(event) {
    this.customerService
      .retryBVNValidation(this.currentUser.token, event.customer)
      .subscribe(data => {
        this.loading = false;
      });
  }
  rejectThisRequest(event) {
    this.model_r = event.model_r;
    this.model_r.request_id = this.loan.request_id;
    this.model_r.level = this.loan.approval_level;
    this.loading = true;
    this.model_r.level = this.loan.approval_level;
    this.loansService
      .rejectThisRequest(this.currentUser.token, event.model_r)
      .subscribe(loans => {
        this.open_approval = !this.open_approval;
        this.loading = false;

        this.dataService.refreshPage.emit();
      });

  }
  cancelThisApproval() {
    this.open_approval = false;
  }
  approveThisRequest(event) {
    this.model_a = event.model_a;
    this.model_a.request_id = this.loan.request_id;
    this.model_a.level = this.loan.approval_level;
    this.loansService
      .approveThisRequest(this.currentUser.token, this.model_a)
      .subscribe(loans => {
        this.dataService.refreshPage.emit();
        this.dataService.approvalDone.emit();
        this.loading = false;
        if (loans.status) {
          this.open_approval = !this.open_approval;
          this.loading = false;

          this.open_approval = !this.open_approval;
        } else {
          if (loans.message) {
            this.showError(loans.message)
          }
        }
        this.open_approval = !this.open_approval;
      });
  }
  navigateToWebSimulate() {
    //let appKey = this.storageService.read<any>('appKey');
    window.open(
      'http://redirect.700lenders.com/?src=' + this.appKeys + '&CC.wc_lc=launch-widget',
      '_blank'
    );
  }
  navigateToUssdSimulate() {
    let appKey = this.storageService.read<any>('appKey');
    window.open(
      'http://redirect.700lenders.com/?src=' + appKey + '&CC.wc_lc=launch-widget',
      '_blank'
    );
  }
  navigateToChatBotSimulate() {
    this.loansService.getAppKey(this.currentUser.token).subscribe(data => {
      window.open(
        'https://cb.creditclan.com/?src=' + data.data.appKey,
        '_blank'
      );
    });
  }
  acceptBorrowerContract() {
    this.loading = true;
    this.loansService
      .acceptContract(this.currentUser.token, this.loan.request_id)
      .subscribe(data => {
        this.loading = false;
        this.is_done = '1';
      });
  }
  runCreditCheck() {
    this.loading = true;

    // this.sub = this.route.params.subscribe(params => {
    //   const parentRouteId = +params['id'];
    //   this.loading = true;

    // });
    this.loansService
      .runCreditCheck(
        this.currentUser.token,
        this.request_id,
        this.bureau_selected
      )
      .subscribe(data => {
        this.loading = false;

        this.is_done = '1';

        // if (data.status == false) {
        //   this.showError(data.message)
        // } else {
        //   this.showSuccess('Successful');
        // }
        // this.DataService.reloadCreditCheck.emit();
      });
  }
  sendBVN() {
    this.loading = true;
    this.loading = false;
    this.is_done = '1';

    this.operationsService.sendBVNRequest(
      this.currentUser.token,
      this.loan.request_id
    );
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
  requestCard() {
    this.loading = true;
    this.loading = false;
    this.is_done = '1';
    this.operationsService.sendCardRequest(
      this.currentUser.token,
      this.loan.request_id
    );
  }
  inviteForAnalytics() {
    this.loading = true;
    this.loading = false;
    this.is_done = '1';
    this.operationsService.inviteForAnalytics(
      this.currentUser.token,
      this.loan.request_id
    );
  }
  sendForOtherDocuments() {
    this.loading = true;
    this.loading = false;
    this.is_done = '1';
    this.operationsService.sendForOtherDocuments(
      this.currentUser.token,
      this.loan.request_id,
      this.other_docs
    );
  }
  sendForGuarantors() {
    this.loading = true;
    this.loading = false;
    this.is_done = '1';
    this.operationsService.sendForGuarantors(
      this.currentUser.token,
      this.loan.request_id,
      this.guarantors_request
    );
  }
  confirmBankAccount() {
    this.loading = true;
    this.loading = false;
    this.is_done = '1';
    this.operationsService.sendAccountConfirmationRequest(
      this.currentUser.token,
      this.loan.request_id
    );
  }
  deleteRequest() {
    this.loading = true;
    this.loansService
      .sendDeleteRequest(
        this.currentUser.token,
        this.loan.request_id,
        this.rejection
      )
      .subscribe(data => {
        this.loading = false;
        this.is_done = '1';
        this.closeChildModal();
      });
  }
  resetFilters() {
    this.filteringLoans = true;
    this.magic_filter.reset = true;
    this.getLoans();
  }
  update(slider, event) {
    slider.onUpdate = event;
    this.magic_filter.min = event.from;
    this.magic_filter.max = event.to;
  }
  update_(slider, event) {
    this.magic_filter.funding = event.from;
  }
  update__(slider, event) {
    this.magic_filter.min = this.min_;
    this.magic_filter.max = event.from;
  }
  continueBSAnalysis() {
    // this.loading = true;
    // this.analyticsService
    //   .doBankStatementAnalysis(
    //     this.currentUser.token,
    //     this.loan,
    //     this.bsrequest,
    //     this.statement
    //   )
    //   .subscribe(data => {
    //     this.loading = false;
    //     if (data.status == true) {
    //       this.showSuccess(data.message);
    //       this.dataService.analysisComplete.emit();
    //     } else {
    //       this.showError(data.message);
    //     }
    //   });
  }
  changeSmsValue() {
    this.sms_value = this.sms_value ? '1' : '';
  }
  changeCallLogsValue() {
    this.call_logs_value = this.call_logs_value ? '1' : '';
  }
  changeSocialValue() {
    this.social_value = this.social_value ? '1' : '';
  }
  changeProfileValue() {
    this.profile_value = this.profile_value ? '1' : '';
  }
  changeGuarantorValue() {
    this.guarantor_value = this.guarantor_value ? '1' : '';
  }
  changeRepaymentValue() {
    this.repayment_value = this.repayment_value ? '1' : '';
  }
  changeCardValue() {
    this.cards_value = this.cards_value ? '1' : '';
  }
  changeAccountValue() {
    this.accounts_value = this.accounts_value ? '1' : '';
  }
  changeDdValue() {
    this.dd_value = this.dd_value ? '1' : '';
  }
  runAnalytics() {
    this.loading = true;
    localStorage.setItem('params', JSON.stringify({ sms: this.sms_value, card: this.cards_value, direct_debit: this.dd_value, calllogs: this.call_logs_value, account: this.accounts_value, guarantor: this.guarantor_value, repayments: this.repayment_value, profile: this.profile_value, social: this.social_value }));
    return new Promise((resolve, reject) => {
      return this.http
        .post<any>(`https://eligibilitytest.creditclan.com/public/requestparams`, {
          request_id: this.request_id
        })
        .toPromise()
        .then(res => {
          this.lender_id = res.lender_id;
          this.borrower_id = res.borrower_id;
          this.principal = res.principal;
          this.maturity_date = res.maturity_date;
          this.account_card_id = res.account_card_id;
          this.loan_request_id = res.loan_request_id;
          this.card_id = res.card_id;
          resolve();
        })
        .then(() => this.getFullAnalytics())
        .catch(err => {
          //console.log(err);
          // reject();
        });
    });
  }
  getFullAnalytics() {

  }
  ngOnDestroy(): void {
    this.activeRequestId = null;
  };
  openSettingsModel(bureau) {
    this.dataService.updatingSettingsExternally.emit({ bureau: bureau, section: bureau });
  }
}



